<template>
  <component :is="layout">
    <slot />
  </component>
</template>

<script>
import { mapActions } from 'vuex';

const DEFAULT_LAYOUT = 'ChuspicLayout'

export default {
  name: 'AppLayout',
  async created() {
    await Promise.all([
      this.fetchUser(),
      this.fetchShoppingCart()
    ]);
  },
  methods: {
    ...mapActions("Auth", ["fetchUser"]),
    ...mapActions("ShoppingCartStore", ["fetchShoppingCart"]),

  },
  computed: {
    layout() {
      const layout = this.$route.meta.layout || DEFAULT_LAYOUT;
      return () => import(`layouts/${layout}.vue`);
    }
  }
}
</script>
